import { GetStaticProps } from 'next';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

// import animationData from 'public/404.json';
import { NextHead } from 'components';

// const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

export default function Index() {
  const t = useTranslations();
  const router = useRouter();

  return (
    <>
      <NextHead title={t('meta.not_found.title')} description={t('meta.not_found.description')} />

      <div className="flex flex-col items-center justify-center bg-gray-50 p-4 text-center">
        <div className="relative mb-6 w-[52.875rem] relative h-[26.125rem]">
          <Image src="/images/404.webp" fill alt="404" title="404 page" />
        </div>
        <h1 className="mb-2 text-2xl font-bold text-gray-800 sm:text-4xl">{t('sahifa_topilmadi')}</h1>
        <p className="sm:text-md mb-6 text-sm text-gray-600">{t('sahifa_topilmadi_desc')}</p>
        <button
          onClick={() => router.push('/')}
          className="sm:text-md rounded-lg bg-green-600 px-6 py-2 text-sm text-white shadow transition hover:bg-green-700"
        >
          {t('bosh_sahifaga_qaytish')}
        </button>
      </div>
    </>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    messages: (await import(`../messages/${locale}.json`)).default
  }
});
